/// <reference path="../presentation.base.ts" />
/// <reference path="DataModel.ts" />

namespace ui
{
	export namespace table
	{

		/**
		 *
		 *
		 * @author Frank Kevin Zey <fkzey (at) gsd-web (dot) de>
		 * @version 1.0.0
		 * @extends ui.base.HTMLPresentation
		 */
		export class Table<T>
			extends ui.base.HTMLPresentation<HTMLDivElement>
		{

			private m_Model: DataModel<T>|undefined;

			public constructor( root?: JQuery<HTMLElement> )
			{
				super( 'div', root );
			}

			public DataModel(): DataModel<T>;
			public DataModel( model: DataModel<T> ): void;
			public DataModel( model?: DataModel<T> ): DataModel<T>|void
			{
				if ( model )
				{
					this.m_Model	= model;

					return;
				}

				return this.m_Model;
			}

			public Data( data?: T[] ): T[]|void
			{
				if ( this.m_Model )
				{
					const reader = this.m_Model.ModelReader();
					if ( reader )
					{
						if ( data )
						{
							reader.Data( data );
							return;
						}

						return reader.Data();
					}
				}

				return [];
			}

			/**
			 * @see ui.base.HTMLPresentation#rebuild
			 */
			public rebuild(): Table<T>
			{
				if ( this.m_Model ) { this.m_Model.present( this.m_Root ); }

				return this;
			}

		}

	}
}
